import { createContext } from "react";
import type {
  CurrentUser,
  CurrentUserFragment,
  PermissionsFragment,
} from "../../../lib/graphql";
import type { ILocalityState } from "./reducer";

export type AuthorizeFnType = (permissions?: PermissionsFragment) => boolean;

export interface UserContextType {
  user?: CurrentUser;
  currentTenant: CurrentUserFragment["currentTenant"];
  currentLocality?: ILocalityState["locality"];
  currentLocalityId?: string;
  currentLocalityIds?: string[];
  localities: ILocalityState["localities"];
  currentCropCycle?: ILocalityState["cropCycle"];
  currentCropCycleId?: string;
  currentCropCycleIds?: string[];
  cropCycles?: ILocalityState["cropCycles"];
  menuCollapsed: boolean;
  forceTenantOnboarding: boolean;
  forceSubscription: boolean;
  forceUserOnboarding: boolean;
  setCurrentTenant(tenantId: string, redirectTo?: string): void;
  setMenuCollapsed(collapsed: boolean): void;
  setCurrentLocality(localityId?: string): void;
  useAuthorized: (
    authorize?: AuthorizeFnType,
    options?: { skipRedirect?: boolean }
  ) => {
    user?: CurrentUserFragment | null;
  };
  setCurrentCropCycle(cropCycleId?: string): void;
  refetch(): Promise<any>;
}

export const UserContext = createContext<UserContextType>({
  menuCollapsed: false,
  currentTenant: {} as CurrentUserFragment["currentTenant"],
  localities: [],
  forceTenantOnboarding: false,
  forceSubscription: false,
  forceUserOnboarding: false,
  setMenuCollapsed: () => {},
  setCurrentTenant: () => {},
  setCurrentLocality: () => {},
  useAuthorized: () => ({}),
  setCurrentCropCycle: () => {},
  refetch: () => Promise.resolve(),
});
